import type { InspectReadoutData } from "../inspectCell";

/**
 * The Inspect tool's readout body (`useInspectTool`): the tile and its properties, the units and
 * assets standing there, walls and clouds, the zones and rooms it is in, and the mechanics groups
 * the board is outlining. Every word comes from {@link InspectReadoutData}; `CombatStage`'s
 * `InspectReadoutFrame` places it beside the cell.
 */
export function InspectReadout({ data }: { data: InspectReadoutData }) {
  return (
    <>
      <div className="combat-inspect-head">
        <span className="combat-inspect-name" data-inspect="name">
          {data.name}
        </span>
        <span className="combat-inspect-coord">{data.key}</span>
      </div>
      {data.lines.length > 0 && (
        <ul className="combat-inspect-section" data-inspect="tile">
          {data.lines.map((line) => (
            <li key={line}>{line}</li>
          ))}
        </ul>
      )}
      {data.units.length > 0 && (
        <ul className="combat-inspect-section" data-inspect="units">
          {data.units.map((u) => (
            <li key={u.id} data-inspect-unit={u.id}>
              <span className="combat-inspect-label">{u.name}</span>
              {u.hp !== null && <span className="combat-inspect-hp">{u.hp}</span>}
              {u.detail !== null && <span className="combat-inspect-detail">{u.detail}</span>}
            </li>
          ))}
        </ul>
      )}
      {data.carriers.length > 0 && (
        <ul className="combat-inspect-section" data-inspect="carriers">
          {data.carriers.map((n) => (
            <li key={n.id}>
              <span className="combat-inspect-label">{n.label}</span>
              <span className="combat-inspect-detail">{n.detail}</span>
            </li>
          ))}
        </ul>
      )}
      {data.zones.length > 0 && (
        <ul className="combat-inspect-section" data-inspect="zones">
          {data.zones.map((z) => (
            <li key={z}>{z}</li>
          ))}
        </ul>
      )}
      {data.regions.length > 0 && (
        <ul className="combat-inspect-section" data-inspect="regions">
          {data.regions.map((r) => (
            <li key={r} className="combat-inspect-region">
              {r}
            </li>
          ))}
        </ul>
      )}
    </>
  );
}
